import { CommonModule, DatePipe } from '@angular/common';
import {
  ChangeDetectorRef,
  Component,
  ElementRef,
  EventEmitter,
  Output,
  Renderer2,
  ViewChild,
} from '@angular/core';
import {
  FormArray,
  FormBuilder,
  FormControl,
  FormGroup,
  FormsModule,
  ReactiveFormsModule,
  Validators,
} from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { DatasearchService } from '../../_services/datasearch.service';
import {
  combineLatest,
  debounceTime,
  distinctUntilChanged,
  Subject,
} from 'rxjs';
import { search_filter } from '../../../_model/search_fliter';
import { AuthenticationService } from '../../_services/authentication.service';
import { ConstantService } from '../../_services/constant.service';
import { GlobalService } from '../../_services/global.service';
import { BusyService } from '../../_services/busy.service';
import { user_privilege } from '../../../_model/user_privilege';
import { DropdownModule } from 'primeng/dropdown';
import { DialogModule } from 'primeng/dialog';
import { DomSanitizer } from '@angular/platform-browser';
import { CommanService } from '../../_services/comman.service';
import { tap, switchMap } from 'rxjs/operators';
import { MessageService } from 'primeng/api';
@Component({
  selector: 'app-advance-search',
  standalone: true,
  imports: [
    FormsModule,
    CommonModule,
    ReactiveFormsModule,
    DropdownModule,
    DialogModule,
  ],
  templateUrl: './advance-search.component.html',
  styleUrl: './advance-search.component.scss',
  providers: [MessageService],
})
export class AdvanceSearchComponent {
  advanceformvalue: any = {};
  isTableAdvance: boolean = false;
  // @Output() receiveAdvancedSearchData = new EventEmitter<{ response: string;
  //   userid: string;
  //   gbrn: string;
  //   INCHIKEY: string;
  //   currentFilterCondition: any;
  //   application_query: string;
  //   search_filters: search_filter;
  //   cols: any;
  //   columns: any;
  //   totalRecords: any;
  //   searchQueryGrid: string ; }>();
  TableName: string = 'templateBasicProductDetailsMongos';
  pageTitile = 'QuikPatent';
  isSignedIn = false;
  tokenChecked = false;
  searchTypeOptions = [
    { type: 'Exact', label: 'Exact Search' },
    {
      type: 'Free',
      label: 'Free text search (Broad Search, it may take more time)',
    },
  ];
  searchOptions: any[] = [
    { name: 'Simple Search', value: 'SIMPLE' },
    { name: 'Advance Search', value: 'ADVANCE' },
    { name: 'Combination Search', value: 'COMBINATION' },
    // { name: "Claim / Example Search", value: "CLAIM" }
  ];
  user_data: any;
  current_pagenumber: number = 1;
  filterForm_normal: FormGroup = new FormGroup({});
  selectedSearchOption = 1;
  searchForm!: FormGroup;
  items: any[] = [];
  selectedOption: string = '';
  formValues: any[] = [];
  results_suggestion: any[] = [];
  dropdownItems: any[] = [];
  isShowQueryBox: boolean = false;
  isShowAutoSearch: boolean = false;
  isShowTable: boolean = false;
  isQueryErrorFound: boolean = false;
  searchQueryGrid: string = '';
  searchType = 'Exact';
  noResultsFound: boolean = false;
  patentTypes: any[] = [];
  addOnPatentTypes: any[] = [];
  filterForm_advanced: FormGroup = new FormGroup({});
  isShowAccessDialog: boolean = false;
  IsFilterAplied: boolean = false;
  analysisApi: boolean = false;
  isQueryOptionSelected: boolean = false;
  IsSuggestedItemClick: boolean = false;
  columns: any[] = [];
  isShowReadMoreDialog: boolean = false;
  initializedForm: boolean = false;
  isListView: boolean = true;
  isShowRaiseQuery: boolean = false;
  is_show_Total_Search_Exceed_popup: boolean = false;
  is_show_Search_Priv_popup: boolean = false;
  is_show_Daily_Search_Exceed_popup: boolean = false;
  is_show_Download_Priv_popup: boolean = false;
  is_show_Daily_Download_Exceed_popup: boolean = false;
  is_show_Total_Download_Exceed_popup: boolean = false;
  productDetails: boolean = false;
  analysisView: boolean = false;
  isValidQueryCondition: boolean = true;
  currentFilterCondition: any = [];
  currentSortBy: string = '';
  application_query: string = '';
  search_filters!: search_filter;
  user_ip: string = '';
  address: string = '';
  additionalOperator: string = '';
  products_current_datasource: any[] = [];
  analysisFilterVal: any = [];
  rptDataForExcel: any = [];
  textsearch = '';
  searchedWords: string[] = [];
  searchFields = ['', 'combination'];
  SuggestedDbColumn: string = '';
  SuggestedDbField: string = '';
  dynSelectedPatentType: string = '';
  lastSearchQuery: string = '';
  readMoreColumn: string = '';
  readMoreContent: string = '';
  dateValue: any = {};
  tablefilter: any = {};
  analysisData: any = {};
  detailViewData: any = {};
  totalRecords: any;
  isLoadAutoSearch: boolean = false;
  updatePrivilege = false;
  loading_table = false;
  first = 0;
  oldResult: any = {};
  oldSearchQueryGrid = '';
  listSortByfield: string = '';
  listSortOrder: string = 'ASC';
  colCntAutoSearch: number = 0;
  privilege_json!: user_privilege;
  public searchTerms = new Subject<string>();
  postdata: any = {
    mode: 'GET_AUTO_SUGGEST',
  };
  searchCondition: any = {};
  isDataExistsAutoSearch: boolean = true;
  filteredProducts: any[] = [];
  dropdownSuggestions: any = [];
  operatorSelected: string = '';
  fieldSelected: string = '';
  matchText: string = '';
  searchValueFromEmail: string | null = null;
  rows: number = 15;
  cols: any[] = [];
  loadingCompleted: boolean = false;
  displayVideoModal: boolean = false;
  videoUrl: any;
  pageLimitInPrivilegeJson: any = 0;
  pageLimitInDatabaseLimit: any = 0;
  regex_query =
    /\s?(?<operator>AND|OR|NOT)?\s?(?<columnname>[\w\s]+):(?<aditional_condition>EQUAL TO|NOT EQUAL TO|BETWEEN|NOT BETWEEN)?\((?<value>.*?)\)/gm;
  // search_regex_query = /\s?(?<operator>AND|OR|NOT)?\s?(?<columnname>[\w\s]+):(?<aditional_condition>EQUAL TO|NOT EQUAL TO|BETWEEN|NOT BETWEEN)?\((?<value>(?:[^(]+|\([^)]*\))*)\)/g;
  search_regex_query =
    /\s*(?<operator>AND|OR|NOT)?\s*(?<columnname>[\w\s]+):(?<aditional_condition>EQUAL TO|NOT EQUAL TO|BETWEEN|NOT BETWEEN)?\s*\((?<value>[^()]*?(?:\s+TO\s+[^()]*?)?)\)\s*/g;
  regex_query1 =
    /\s?(?<operator>AND|OR|NOT)?\s?(?<columnname>[\w\s]+):(?<aditional_condition>EQUAL TO|NOT EQUAL TO|BETWEEN|NOT BETWEEN)?\((?<value>.*?)\)/gm;
  regex_query2 = /\s?(?<operator>AND|OR|NOT)?\s?(?<columnname>[\w\s]+)/gi;

  querySuggestions: any = [
    { search_value: 'AND', columnName: 'AND', label: 'Operator' },
    { search_value: 'OR', columnName: 'OR', label: 'Operator' },
    { search_value: 'NOT', columnName: 'NOT', label: 'Operator' },
    {
      search_value: 'EQUAL TO',
      columnName: 'EQUAL TO',
      label: 'Date Operator',
    },
    {
      search_value: 'NOT EQUAL TO',
      columnName: 'NOT EQUAL TO',
      label: 'Date Operator',
    },
    { search_value: 'BETWEEN', columnName: 'BETWEEN', label: 'Date Operator' },
    {
      search_value: 'NOT BETWEEN',
      columnName: 'NOT BETWEEN',
      label: 'Date Operator',
    },
    { search_value: '(term)', columnName: '(term)', label: 'Field Text' },
    {
      search_value: '(term1 AND term2)',
      columnName: '(term1 AND term2)',
      label: 'Field Text',
    },
    {
      search_value: '(term1 OR term2)',
      columnName: '(term1 OR term2)',
      label: 'Field Text',
    },
    {
      search_value: '(dd-mm-yyyy TO *)',
      columnName: '(dd-mm-yyyy TO *)',
      label: 'Field Date',
    },
    {
      search_value: '(dd-mm-yyyy TO dd-mm-yyyy)',
      columnName: '(dd-mm-yyyy TO dd-mm-yyyy)',
      label: 'Field Date',
    },
    {
      search_value: '(dd-mm-yyyy TO * AND dd-mm-yyyy TO dd-mm-yyyy)',
      columnName: '(dd-mm-yyyy TO * AND dd-mm-yyyy TO dd-mm-yyyy)',
      label: 'Field Date',
    },
    {
      search_value: '(dd-mm-yyyy TO * OR dd-mm-yyyy TO dd-mm-yyyy)',
      columnName: '(dd-mm-yyyy TO * OR dd-mm-yyyy TO dd-mm-yyyy)',
      label: 'Field Date',
    },
    {
      search_value: '(dd-mm-yyyy TO dd-mm-yyyy AND dd-mm-yyyy TO dd-mm-yyyy)',
      columnName: '(dd-mm-yyyy TO dd-mm-yyyy AND dd-mm-yyyy TO dd-mm-yyyy)',
      label: 'Field Date',
    },
    {
      search_value: '(dd-mm-yyyy TO dd-mm-yyyy OR dd-mm-yyyy TO dd-mm-yyyy)',
      columnName: '(dd-mm-yyyy TO dd-mm-yyyy OR dd-mm-yyyy TO dd-mm-yyyy)',
      label: 'Field Date',
    },
  ];
  constructor(
    private datasearch: DatasearchService,
    private authentication: AuthenticationService,
    private _constant: ConstantService,
    private fb: FormBuilder,
    private datePipe: DatePipe,
    private busyService: BusyService,
    private changeDetectorRef: ChangeDetectorRef,
    private renderer: Renderer2,
    private route: ActivatedRoute,
    private commanService: CommanService,
    private router: Router,
    private sanitizer: DomSanitizer,
    private messageService: MessageService,
    private globalService: GlobalService
  ) {
    this.setIpandLocation();
    this.filterForm_normal = this.fb.group({
      textautocomplete: new FormControl(''),
    });
  }
  criteria: any[] = [1]; // Initialize with one criteria row

  ngOnInit() {
    this.privilege_json = this.authentication.getUserPrivilege();

    this.authentication.getLoginUser().subscribe((val) => {
      this.isSignedIn = val;
      if (this.isSignedIn) {
        this.loadSearchCols();
        this.getUserPrivilege();
      }
    });
    // this.authentication.getLoginUser().subscribe((val) => {
    //   this.isSignedIn = val;
    //   if (this.isSignedIn) {
    //     this.loadSearchCols();
    //     this.getUserPrivilege();
    //     // this.loadTableConfig();
    //     // this.loadColumnDetails();
    //     // this.loadPatents();
    //     // this.route.queryParams.subscribe((params) => {
    //     //   const findParam = params['find'];
    //     //   if (findParam) {
    //     //     // console.log("find preset")
    //     //     this.searchValueFromEmail = decodeURIComponent(findParam).replace(
    //     //       /%20/g,
    //     //       ' '
    //     //     );
    //     //     if (this.searchValueFromEmail) {
    //     //       this.isShowTable = true;
    //     //       this.searchQueryGrid = this.searchValueFromEmail;
    //     //       this.filterForm_normal
    //     //         .get('textautocomplete')
    //     //         ?.setValue('Chlorantraniliprole');
    //     //       this.searchQuery();
    //     //       setTimeout(() => {
    //     //         this.searchQuery();
    //     //       }, 1000);
    //     //     }
    //     //   }
    //     // });
    //   }
    // });
    this.filterForm_advanced = this.fb.group({
      advfilters: this.fb.array([]),
      ddloprator: ['', Validators.required],
      txtfiltervalue: ['', Validators.required],
    });

    // Get isTable value
    this.commanService.isTableAdvance.subscribe((res) => {
      this.isTableAdvance = res;
    });
    // This method get page limit data for XIM 1.0
    this.datasearch
      .GetDatabasePageLimit({
        database: 'AgroPat Ultimate Discovery Suite Beta',
      })
      .subscribe(
        (res: any) => {
          if (res.status) {
            this.pageLimitInDatabaseLimit = res.data.page_limit
              ? Number(res.data.page_limit)
              : 0;
          } else {
            console.log('Error success false');
          }
        },
        (error: any) => {
          console.log('Error :', error);
        }
      );
    // Get current page number and row
    combineLatest([
      this.commanService.currentPage,
      this.commanService.currentRow,
    ]).subscribe(([page, row]) => {
      if (this.current_pagenumber !== page || this.rows !== row) {
        this.current_pagenumber = page;
        this.rows = row;

        this.handlePageLimit();
        if (this.pageLimitInPrivilegeJson) {
          if (this.current_pagenumber > +this.pageLimitInPrivilegeJson) {
            this.commanService.userPageLimit.next(
              this.pageLimitInPrivilegeJson
            );
            this.commanService.showPageLimitWarning.next(true);
            setTimeout(() => {
              this.commanService.showPageLimitWarning.next(false);
            }, 1000);

            return;
          }
        } else if (this.pageLimitInDatabaseLimit) {
          if (this.current_pagenumber > +this.pageLimitInDatabaseLimit) {
            this.commanService.userPageLimit.next(
              this.pageLimitInDatabaseLimit
            );
            this.commanService.showPageLimitWarning.next(true);
            setTimeout(() => {
              this.commanService.showPageLimitWarning.next(false);
            }, 1000);

            return;
          }
        }

        if (this.isTableAdvance) {
          this.search();
        }
      }
    });

    this.globalService.sendMenuIndex(0);
    this.initializeForm();
    this.getdropdown();
    this.updatesimplesearch();

    // /////////////// Search By Email ///////////////
    this.globalService.getSearchByEmail_Data().subscribe((res) => {
      if (res) {
        if (res.searchType == 'Advance') {
          setTimeout(() => {
            this.filterForm_advanced.setValue(res.searchValue);
            this.search();
            this.globalService.setSearchByEmail_Data(null);
          }, 2000);
        }
      }
    });
    this.commanService.resetFlag.subscribe((reset) => {
      if (reset) {
        this.resetForm();

        this.commanService.resetFlag.next(false);
      }
    });
  }

  searchQuery() {
    // this.oldResult = {
    //   products_current_datasource: this.products_current_datasource,
    //   totalRecords: this.totalRecords,
    //   searchQueryGrid: this.oldSearchQueryGrid
    // }
    // this.showAnalysisView(true);
    this.analysisView = false;
    this.isQueryOptionSelected = true;
    // this.isQueryOptionSelected=false;
    this.isQueryErrorFound = false;
    //replace more than one space
    this.searchQueryGrid = this.searchQueryGrid.replace(/\s{2,}/gm, '');
    this.lastSearchQuery = JSON.stringify(this.searchQueryGrid);
    this.searchData();
  }
  initializeForm() {
    // Advance Form
    this.filterForm_advanced = this.fb.group({
      ddlpatenttype: [''],
      search_type_advance: ['Exact', Validators.required],
      advfilters: this.fb.array([
        this.fb.group({
          ddloprator: new FormControl('AND', [Validators.required]),
          ddlfieldnameadv: new FormControl('select', [Validators.required]),
          txtfiltervalue: new FormControl('', [Validators.required]),
        }),
        this.fb.group({
          ddloprator: new FormControl('AND', [Validators.required]),
          ddlfieldnameadv: new FormControl('select', [Validators.required]),
          txtfiltervalue: new FormControl('', [Validators.required]),
        }),
        this.fb.group({
          ddloprator: new FormControl('AND', [Validators.required]),
          ddlfieldnameadv: new FormControl('select', [Validators.required]),
          txtfiltervalue: new FormControl('', [Validators.required]),
        }),
      ]),
    });
    this.initializedForm = true;
  }
  private existingValues: { [key: string]: boolean } = {};
  loadSearchCols() {
    let postdata = {
      tablename: this.TableName,
    };
    this.datasearch.GetTemplateCols(postdata).subscribe((res) => {
      this.columns = res.data;
      console.log('advance search col : ', this.columns);

      this.columns.sort((a: any, b: any) => {
        return a.DisplayColumnName.localeCompare(b.DisplayColumnName);
      });
      this.columns.forEach((col) => {
        if (!this.existingValues[col.tableColumnName]) {
          this.querySuggestions.push({
            search_value: col.tableColumnName,
            columnName: col.DisplayColumnName,
            label: 'Field',
            fieldDataType: col.fieldDataType,
          });
          this.existingValues[col.tableColumnName] = true;
        }
      });
      if (!this.existingValues['patentType']) {
        this.querySuggestions.push({
          search_value: 'patentType',
          columnName: 'PATENT TYPE',
          label: 'Field',
        });
        this.existingValues['patentType'] = true;
      }
    });
  }
  getUserPrivilege() {
    const currentUser = JSON.parse(localStorage.getItem('currentUser') || '{}');
    const userId = currentUser?.userid;

    // ✅ Extract correct privilege object from API response
    const privilege =
      currentUser?.user_privilege?.[`user_${userId}`]?.[
        'agropat-ultimate-discovery-suite-beta'
      ] || null;

    if (privilege) {
      this.privilege_json = privilege;
      localStorage.setItem('userPrivilege', JSON.stringify(privilege));
      console.log('✅ Privilege set for QuickPatent:', this.privilege_json);
    } else {
      console.warn('⚠ No QuickPatent privilege found for user.');
    }
  }
  staticSuggestion(columnname: any, title: any, search_value: any) {
    switch (columnname) {
      case 'keyword':
        this.IsSuggestedItemClick = false;
        this.SuggestedDbColumn = '';
        this.filterForm_normal.controls['textautocomplete'].setValue(
          search_value
        );
        this.search();
        break;
      default:
        let searchItem = {
          columnname: columnname,
          field: title,
          search_value: search_value,
        };
        this.autoSearchSelect(searchItem);
        break;
    }
  }
  handlePageLimit() {
    this.pageLimitInPrivilegeJson =
      this.privilege_json.PageLimit || 0 ? this.privilege_json.PageLimit : 0;
  }
  truncateName(name: string, maxWords: number): string {
    const words = name.split(' ');
    return words.slice(0, maxWords).join(' ');
  }
  autoSearchSelect(searchItem: any) {
    this.IsSuggestedItemClick = true;
    this.SuggestedDbColumn = searchItem.columnname;
    this.SuggestedDbField = searchItem.field;
    this.filterForm_normal.controls['textautocomplete'].setValue(
      searchItem.search_value
    );
    this.search();
  }
  addCriterion() {
    this.criteria.push({}); // Add a new criterion
  }

  removeCriterion(index: number) {
    if (this.criteria.length > 1) {
      this.criteria.splice(index, 1); // Remove the criterion at the specified index
    }
  }
  showVideoModal() {
    // URL of the video you want to display
    const videoLink =
      'https://www.chemrobotics.com/agropat/uploads/web_videos/ChemRobotics-AgroPat-Tutorial-Agrochemical-Pesticide.mp4';
    // Sanitize the URL and store it in videoUrl
    this.videoUrl = this.sanitizer.bypassSecurityTrustResourceUrl(videoLink);

    this.displayVideoModal = true; // Open the modal
  }
  // redirectToPage() {
  //   this.router.navigate(['/search']); // Replace '/next-page' with your desired route
  // }
  getdropdown() {
    this.datasearch.getdropdown().subscribe(
      (res: any) => {
        console.log('🚀 getdropdown() called and API responded:', res);

        // ✅ Extract array safely from new API format
        const columnsArray = Array.isArray(res?.data?.results)
          ? res.data.results
          : [];

        console.log('✅ Full API Response:', res);
        console.log('📦 Extracted Columns Array:', columnsArray);

        if (!columnsArray.length) {
          console.error('🚫 No valid dropdown data found in response');
          return;
        }

        // ✅ Filter items with viewInDropdown flag (handles true, 1, "true")
        const visibleItems = columnsArray.filter(
          (item: any) =>
            item.viewInDropdown === true ||
            item.viewInDropdown === 1 ||
            item.viewInDropdown === 'true'
        );

        // ✅ Process data to truncate labels for dropdown display
        this.dropdownItems = visibleItems.map((item: any) => ({
          ...item,
          truncatedLabel: this.truncateName(
            item.displayColumnName ||
              item.header ||
              item.excelColumnName ||
              item.field, // fallback
            5
          ),
        }));

        console.log('🎯 Filtered Dropdown Items:', this.dropdownItems);
      },
      (error) => {
        console.error('❌ Error fetching dropdown data:', error);
      }
    );
  }

  get advfilters(): FormArray {
    return this.filterForm_advanced.controls['advfilters'] as FormArray;
  }
  getFieldType(fieldname: any) {
    return this.columns.find((item) => item.tableColumnName == fieldname)
      ?.fieldDataType;
  }
  addFilter() {
    const advfilterForm = this.fb.group({
      ddloprator: new FormControl('AND', [Validators.required]),
      ddlfieldnameadv: new FormControl('select', [Validators.required]),
      txtfiltervalue: new FormControl('', [Validators.required]),
    });
    this.advfilters.push(advfilterForm);
  }
  deleteFilter(advfilterIndex: number) {
    this.advfilters.removeAt(advfilterIndex);
  }

  search() {
    this.updatePrivilege = true;
    this.results_suggestion = [];
    this.isShowAutoSearch = false;
    if (this.checkUserSearchPrivillege() == false) {
      return;
    }
    this.isShowTable = false;
    this.isQueryErrorFound = false;
    this.searchQueryGrid = '';
    this.searchData();
  }

  // searchData(showDetailView?: boolean) {
  //   this.isShowQueryBox = false;

  //   // Only handle ADVANCE search
  //   if (this.searchOptions[this.selectedSearchOption].value === 'ADVANCE') {
  //     let selectedAdvFilter: boolean = false;

  //     // Check if any advanced filters are selected
  //     for (let i = 0; i < this.filterForm_advanced.value.advfilters.length; i++) {
  //       if (
  //         this.filterForm_advanced.value.advfilters[i].ddlfieldnameadv !== '' &&
  //         this.filterForm_advanced.value.advfilters[i].txtfiltervalue !== ''
  //       ) {
  //         selectedAdvFilter = true;
  //         break;
  //       }
  //     }

  //     // If no advanced filters are selected, do not proceed with search
  //     if (!selectedAdvFilter) {
  //       return;
  //     }
  //   }

  //   // Generate filter condition for the query
  //   this.currentFilterCondition = this.getFilterCondition();

  //   // Ensure we have filter conditions before proceeding
  //   if (this.currentFilterCondition.length > 0) {
  //     this.currentFilterCondition.push({ isDeleted: { $ne: true } });
  //   }

  //   // If no filter condition is generated, stop the search
  //   if (this.currentFilterCondition.length === 0) {
  //     return;
  //   }

  //   // Create postdata to send to API
  //   let postdata = {
  //     mode: 'GET_DATA',
  //     tablename: this.TableName,
  //     filterconditionQuikPatent: this.currentFilterCondition,
  //     pagenumber: this.current_pagenumber,
  //     rowscount: this.rows,
  //     sortby: this.currentSortBy,
  //     application_query: this.application_query,
  //     updatePrivilege: this.updatePrivilege,
  //     search_filters: this.search_filters,
  //     user_ip: this.user_ip ? this.user_ip : null,
  //     address: this.address ? this.address : null,
  //     userid: this.user_data.userid,
  //   };

  //   // Start the API call with the discovery_suite_data_count for pagination count
  //   this.busyService.busy();
  //   this.datasearch.discovery_suite_data_count(postdata).pipe(
  //     tap((res: any) => {
  //       let response = res;
  //       if (response?.status === 'error') {
  //         this.busyService.idle();
  //         return;
  //       }

  //       this.totalRecords = response[0]?.TotalRecordsCount || 0;
  //       this.loadingCompleted = true;

  //       // Check if no records are found
  //       if (this.totalRecords === 0) {
  //         this.noResultsFound = true;
  //       } else {
  //         this.noResultsFound = false;
  //       }
  //     }),
  //     switchMap(() => {
  //       // After `discovery_suite_data_count`, proceed with `get_suite_data`
  //       return this.datasearch.get_suite_data(postdata);
  //     })
  //   ).subscribe(
  //     (res: any) => {
  //       this.busyService.idle();
  //       let response: any = res[0];

  //       if (response?.status === 'error') {
  //         return;
  //       }

  //       // Process response data
  //       const gbrnArray = response.map((item: any) => item.gbrn);
  //       const inchiKeyArray = response.map((item: any) => item.INCHIKEY);
  //       this.commanService.currentData.next({
  //         INCHIKEY: response[0]?.INCHIKEY,
  //         gbrn: response[0]?.gbrn,
  //         data: response,
  //         userid: this.user_data.userid,
  //         currentFilterCondition: this.currentFilterCondition,
  //         application_query: this.application_query,
  //         search_filters: this.search_filters,
  //         cols: res[1] || [],
  //         columns: this.columns,
  //         totalRecords: this.totalRecords,
  //         searchQueryGrid: this.searchQueryGrid,
  //         gbrnArray: gbrnArray,
  //         inchiKeyArray: inchiKeyArray
  //       });

  //       this.commanService.isTableAdvance.next(true);
  //       this.commanService.advanceformvalue.next(this.filterForm_advanced.value);
  //       this.router.navigate(['/search']);
  //       this.products_current_datasource = res[0];
  //       this.cols = res[1];

  //       // Handle column width and date formatting
  //       this.cols.forEach((field) => {
  //         field.columnWidth = parseInt(field.columnWidth.replace('px', ''));
  //       });

  //       this.products_current_datasource.forEach((item) => {
  //         this.cols.forEach((x) => {
  //           if (x.fieldDataType === 'date') {
  //             if (item[x.field] === '0000-00-00') {
  //               item[x.field] = '';
  //             } else {
  //               try {
  //                 item[x.field] = this.datePipe.transform(item[x.field], 'yyyy-MM-dd');
  //               } catch (e) {
  //                 // Handle any date transformation errors
  //               }
  //             }
  //           }
  //         });
  //       });

  //       // Optional sorting logic (based on priorities and dates)
  //       if (!postdata.sortby) {
  //         this.products_current_datasource.sort((a, b) => {
  //           if (a.priority === '' && b.priority !== '') {
  //             return 1;
  //           } else if (a.priority !== '' && b.priority === '') {
  //             return -1;
  //           } else {
  //             const priorityComparison = a.priority - b.priority;
  //             if (priorityComparison !== 0) {
  //               return priorityComparison;
  //             } else {
  //               if (a.applicationDate === null && b.applicationDate !== null) {
  //                 return 1;
  //               } else if (a.applicationDate !== null && b.applicationDate === null) {
  //                 return -1;
  //               } else {
  //                 return (
  //                   new Date(a.applicationDate).getTime() -
  //                   new Date(b.applicationDate).getTime()
  //                 );
  //               }
  //             }
  //           }
  //         });
  //       }

  //       // Set serial number for each record
  //       this.products_current_datasource.forEach((row, index) => {
  //         row.S_NO = (this.current_pagenumber - 1) * this.rows + index + 1;
  //       });

  //       this.isShowTable = true;
  //     },
  //     (error) => {
  //       this.busyService.idle();
  //     },
  //     () => {
  //       this.busyService.idle();
  //       this.loading_table = false;
  //     }
  //   );
  // }
  tableData: any = null;
  isDataApiDone: boolean = false;
  isCountApiDone: boolean = false;
  searchData(showDetailView?: boolean) {
    this.isDataApiDone = false;
    this.isCountApiDone = false;
    this.isShowQueryBox = false;

    // 🔹 Handle only ADVANCE search
    if (this.searchOptions[this.selectedSearchOption].value === 'ADVANCE') {
      const selectedAdvFilter = this.filterForm_advanced.value.advfilters.some(
        (f: any) => f.ddlfieldnameadv !== '' && f.txtfiltervalue !== ''
      );
      if (!selectedAdvFilter) return;
    }

    // 🔹 Generate filter conditions (criteria array)
    this.currentFilterCondition = this.getFilterCondition(); // should return array like [{ field, keyword, operator }]
    if (
      !this.currentFilterCondition ||
      this.currentFilterCondition.length === 0
    ) {
      console.warn('⚠️ No search criteria found');
      return;
    }

    // ✅ Fetch user info safely from localStorage
    const currentUser = JSON.parse(localStorage.getItem('currentUser') || '{}');
    const userId = currentUser?.userid || 'guest';
    const userIp = currentUser?.userIp || '0.0.0.0';
    const address = currentUser?.address || 'Unknown';

    // 🔹 Construct new payload as per latest API spec
    const postdata = {
      search_type:
        this.searchOptions[this.selectedSearchOption]?.value || 'free',
      criteria: this.currentFilterCondition,
      pagenumber: this.current_pagenumber || 1,
      rowscount: this.rows || 10,
      sortby: this.currentSortBy,
      activityObj: {
        userId: userId,
        userEmail:this.user_data?.email || '',
        privilegeName: 'discovery_suite_access',
        mode: 'search',
        query: this.application_query || 'N/A',
        searchFilters: this.search_filters || 'N/A',
        userIp: userIp,
        address: address,
      },
    };

    console.log('📤 Final API Payload:', postdata);

    // 🔹 Start loader
    this.busyService.busy();

    // 🔹 Call the updated API
    this.datasearch.get_suite_data(postdata).subscribe(
      (res: any) => {
        this.busyService.idle();

        if (!res?.status || !res?.data) {
          console.error('❌ Invalid API response:', res);
          return;
        }

        const responseData = res.data.results || [];
        const totalCount = res.data.totalCount || 0;

        this.tableData = responseData;
        this.totalRecords = totalCount;
        this.isDataApiDone = true;

        // if (responseData.length === 0) {
        //   console.warn('⚠️ No records found');
        //   this.isShowTable = false;
        //   return;
        // }

        // 🔹 Format column widths if defined
        if (Array.isArray(this.columns)) {
          this.columns.forEach((col) => {
            if (col.columnWidth) {
              col.columnWidth = parseInt(col.columnWidth.replace('px', ''));
            }
          });
        }

        // 🔹 Handle date formatting in data
        this.tableData.forEach((item: any) => {
          this.columns?.forEach((col) => {
            if (col.fieldDataType === 'date') {
              if (item[col.field] === '0000-00-00') {
                item[col.field] = '';
              } else {
                try {
                  item[col.field] = this.datePipe.transform(
                    item[col.field],
                    'yyyy-MM-dd'
                  );
                } catch {}
              }
            }
          });
        });

        // 🔹 Sorting logic if no custom sort applied
        if (!postdata.sortby) {
          this.tableData.sort((a: any, b: any) => {
            if (a.priority === '' && b.priority !== '') return 1;
            if (a.priority !== '' && b.priority === '') return -1;

            const priorityComparison =
              (parseInt(a.priority) || 0) - (parseInt(b.priority) || 0);
            if (priorityComparison !== 0) return priorityComparison;

            const dateA = a.applicationDate
              ? new Date(a.applicationDate).getTime()
              : 0;
            const dateB = b.applicationDate
              ? new Date(b.applicationDate).getTime()
              : 0;
            return dateA - dateB;
          });
        }

        // 🔹 Add Serial Numbers
        this.tableData.forEach(
          (row: any, index: number) =>
            (row.S_NO = (this.current_pagenumber - 1) * this.rows + index + 1)
        );

        // 🔹 Final UI and communication updates
        this.isShowTable = true;
        this.commanService.isTableAdvance.next(true);
        this.commanService.advanceformvalue.next(
          this.filterForm_advanced.value
        );

        const searchState = {
          data: this.tableData,
          allData: this.tableData,
          userid: [this.user_data?.userid],
          privilege_json: this.privilege_json,
          currentFilterCondition: this.currentFilterCondition,
          application_query: this.application_query,
          search_filters: this.search_filters,
          cols: this.cols,
          columns: this.columns,
          totalRecords: this.totalRecords,
          oldRecords: this.totalRecords,
          searchQueryGrid: this.searchQueryGrid,
        };

        this.commanService.currentData.next(searchState);
        this.router.navigate(['/search']);

        this.dataForTable(this.tableData, this.totalRecords);
      },
      (error) => {
        this.busyService.idle();
        console.error('❌ Error fetching data:', error);
      },
      () => {
        this.busyService.idle();
        this.loading_table = false;
      }
    );
  }

  getFilterCondition() {
    this.textsearch = '';
    this.analysisApi = false;
    this.search_filters = new search_filter();
    this.searchedWords = [];
    this.searchQueryGrid = '';

    let criteriaArr: any[] = [];

    // Normalize for consistent matching
    const normalizeField = (str: string) =>
      str
        ?.toLowerCase()
        .replace(/[^a-z0-9]/g, '')
        .trim();
    if (
      !this.isQueryOptionSelected &&
      this.searchOptions[this.selectedSearchOption].value === 'ADVANCE'
    ) {
      const advFilters = this.filterForm_advanced.value.advfilters;

      this.search_filters.SeachType = 'Advanced Filter';
      this.search_filters.textColumn = [];
      this.search_filters.textValue = [];

      advFilters.forEach((f: any, index: number) => {
        if (!f.ddlfieldnameadv || !f.txtfiltervalue) return;

        const columnname = f.ddlfieldnameadv;
        const columnvalue = f.txtfiltervalue.trim();
        const operator = f.ddloprator?.toUpperCase() || 'AND';

        this.search_filters.textColumn.push(columnname);
        this.search_filters.textValue.push(columnvalue);
        this.searchedWords.push(columnvalue);

        // Find matching column from DB definitions
        const selectedCol = this.columns.find((col: any) => {
          return (
            normalizeField(col.tableColumnName) ===
              normalizeField(columnname) ||
            normalizeField(col.displayColumnName) === normalizeField(columnname)
          );
        });

        if (!selectedCol) {
          console.warn('⚠ Column not found:', columnname);
          return;
        }

        const tableField = selectedCol.tableColumnName; // ALWAYS correct camelCase
        const displayName = selectedCol.displayColumnName || tableField;
        const fieldType = selectedCol.fieldDataType || 'string';

        // 👉 PUSH ALL CRITERIA (multiple fields & values)
        criteriaArr.push({
          field: tableField,
          keyword: fieldType === 'number' ? Number(columnvalue) : columnvalue,
          operator: operator,
        });

        // Build query string for UI
        if (index === 0) {
          this.searchQueryGrid = `${displayName}:(${columnvalue})`;
        } else {
          this.searchQueryGrid += ` ${operator} ${displayName}:(${columnvalue})`;
        }
      });

      this.application_query = this.searchQueryGrid.trim();
      console.log('🚀 Final Advanced Criteria:', criteriaArr);

      return criteriaArr;
    }

    if (this.isQueryOptionSelected) {
      let queryCondition: any[] = [];
      const str = this.searchQueryGrid.trim();

      const parts = str.split(/\s+(AND|OR|NOT)\s+/i);

      for (let i = 0; i < parts.length; i++) {
        const part = parts[i].trim();
        if (['AND', 'OR', 'NOT'].includes(part.toUpperCase())) continue;

        const [fieldNameRaw, valueRaw] = part.split(':(');
        if (!fieldNameRaw || !valueRaw) continue;

        const columnname = fieldNameRaw.trim();
        const columnvalue = valueRaw.replace(')', '').trim();

        const operator =
          parts[i + 1] &&
          ['AND', 'OR', 'NOT'].includes(parts[i + 1].toUpperCase())
            ? parts[i + 1].toUpperCase()
            : 'AND';

        // Find correct camelCase column
        const selectedCol = this.columns.find(
          (col: any) =>
            normalizeField(col.displayColumnName) ===
              normalizeField(columnname) ||
            normalizeField(col.tableColumnName) === normalizeField(columnname)
        );

        if (!selectedCol) continue;

        queryCondition.push({
          field: selectedCol.tableColumnName,
          keyword: columnvalue,
          operator: operator,
        });
      }

      this.application_query = this.searchQueryGrid.trim();
      console.log('🔍 Final Query Builder Criteria:', queryCondition);

      return queryCondition;
    }
    return [];
  }

  dateConditionArr(colValArr: any, columnname: any, operator: any, i: any) {
    let andArr: any = [];
    let orArr: any = [];
    let searchCondition: any = [];
    if (operator === 'NOT') {
      if (colValArr[1]) {
        searchCondition.push({ $and: [] });
        searchCondition[0]['$and'].push({
          $expr: {
            $lte: [
              { $toDate: `$${columnname}` },
              { $toDate: this.datePipe.transform(colValArr[0], 'yyyy-MM-dd') },
            ],
          },
        });
        searchCondition[0]['$and'].push({
          $expr: {
            $gte: [
              { $toDate: `$${columnname}` },
              { $toDate: this.datePipe.transform(colValArr[1], 'yyyy-MM-dd') },
            ],
          },
        });
      } else {
        searchCondition.push({
          $expr: {
            $ne: [
              { $toDate: `$${columnname}` },
              { $toDate: this.datePipe.transform(colValArr[0], 'yyyy-MM-dd') },
            ],
          },
        });
      }
    } else {
      if (colValArr[1]) {
        searchCondition.push({ $and: [] });
        searchCondition[0]['$and'].push({
          $expr: {
            $gte: [
              { $toDate: `$${columnname}` },
              { $toDate: this.datePipe.transform(colValArr[0], 'yyyy-MM-dd') },
            ],
          },
        });
        searchCondition[0]['$and'].push({
          $expr: {
            $lte: [
              { $toDate: `$${columnname}` },
              { $toDate: this.datePipe.transform(colValArr[1], 'yyyy-MM-dd') },
            ],
          },
        });
      } else {
        searchCondition.push({
          $expr: {
            $eq: [
              { $toDate: `$${columnname}` },
              { $toDate: this.datePipe.transform(colValArr[0], 'yyyy-MM-dd') },
            ],
          },
        });
      }
    }

    if (i === 0 || operator === 'OR') {
      orArr.push({ $or: searchCondition });
    } else {
      andArr.push({ $or: searchCondition });
    }
    // });
    if (orArr.length > 0) {
      andArr.push({ $or: orArr });
    }
    return andArr;
  }
  splitColumnValue(
    columnValue: any,
    columnname: any,
    valType: any,
    operator: any
  ) {
    let colValArr: any = [];
    if (columnname === 'patentType') {
      return this.patentCondition(columnValue, columnname, operator);
    } else if (columnname === 'dummy1') {
      return this.rangeCondition(columnValue, columnname, operator);
    } else if (
      columnValue.toLowerCase().indexOf('and') >= 0 ||
      columnValue.toLowerCase().indexOf('or') >= 0
    ) {
      let strArr = columnValue.split(/\sand\s|\sor\s/gi);
      let opStr = columnValue.match(/\b(?:and|or)\b/gi);
      strArr.forEach((str: any, index: any) => {
        colValArr.push({
          operator: index === 0 ? 'AND' : opStr[index - 1].toUpperCase(),
          value: str,
        });
      });
      return valType === 'text'
        ? this.textFieldCondition(colValArr, columnname, operator)
        : this.dateFieldCondition(colValArr, columnname, operator);
    } else {
      colValArr.push({ operator: 'AND', value: columnValue });
      return valType === 'text'
        ? this.textFieldCondition(colValArr, columnname, operator)
        : this.dateFieldCondition(colValArr, columnname, operator);
    }
  }

  dateFieldCondition(colValArr: any, columnname: any, operator: any) {
    let andArr: any = [];
    let orArr: any = [];
    colValArr.forEach((val: any, i: any) => {
      let inputValue = val.value.split('TO');
      for (let i = 0; i < inputValue.length; i++) {
        if (inputValue[i].indexOf('*') < 0) {
          let dateArr = inputValue[i].split('-');
          inputValue[i] =
            dateArr[2].trim() +
            '-' +
            dateArr[1].trim() +
            '-' +
            dateArr[0].trim();
        } else {
          inputValue[i] = inputValue[i].trim();
        }
      }
      let searchCondition: any = [];
      if (operator === 'NOT') {
        if (inputValue[1]) {
          if (inputValue[0] === '*') {
            searchCondition.push({
              $expr: {
                $gte: [
                  { $toDate: `$${columnname}` },
                  {
                    $toDate: this.datePipe.transform(
                      inputValue[1],
                      'yyyy-MM-dd'
                    ),
                  },
                ],
              },
            });
          } else if (inputValue[1] === '*') {
            searchCondition.push({
              $expr: {
                $lte: [
                  { $toDate: `$${columnname}` },
                  {
                    $toDate: this.datePipe.transform(
                      inputValue[0],
                      'yyyy-MM-dd'
                    ),
                  },
                ],
              },
            });
          } else {
            searchCondition.push({ $and: [] });
            searchCondition[0]['$and'].push({
              $expr: {
                $lte: [
                  { $toDate: `$${columnname}` },
                  {
                    $toDate: this.datePipe.transform(
                      inputValue[0],
                      'yyyy-MM-dd'
                    ),
                  },
                ],
              },
            });
            searchCondition[0]['$and'].push({
              $expr: {
                $gte: [
                  { $toDate: `$${columnname}` },
                  {
                    $toDate: this.datePipe.transform(
                      inputValue[1],
                      'yyyy-MM-dd'
                    ),
                  },
                ],
              },
            });
          }
        } else {
          searchCondition.push({
            $expr: {
              $ne: [
                { $toDate: `$${columnname}` },
                {
                  $toDate: this.datePipe.transform(inputValue[0], 'yyyy-MM-dd'),
                },
              ],
            },
          });
        }
      } else {
        if (inputValue[1]) {
          if (inputValue[0] === '*') {
            searchCondition.push({
              $expr: {
                $lte: [
                  { $toDate: `$${columnname}` },
                  {
                    $toDate: this.datePipe.transform(
                      inputValue[1],
                      'yyyy-MM-dd'
                    ),
                  },
                ],
              },
            });
          } else if (inputValue[1] === '*') {
            searchCondition.push({
              $expr: {
                $gte: [
                  { $toDate: `$${columnname}` },
                  {
                    $toDate: this.datePipe.transform(
                      inputValue[0],
                      'yyyy-MM-dd'
                    ),
                  },
                ],
              },
            });
          } else {
            searchCondition.push({ $and: [] });
            searchCondition[0]['$and'].push({
              $expr: {
                $gte: [
                  { $toDate: `$${columnname}` },
                  {
                    $toDate: this.datePipe.transform(
                      inputValue[0],
                      'yyyy-MM-dd'
                    ),
                  },
                ],
              },
            });
            searchCondition[0]['$and'].push({
              $expr: {
                $lte: [
                  { $toDate: `$${columnname}` },
                  {
                    $toDate: this.datePipe.transform(
                      inputValue[1],
                      'yyyy-MM-dd'
                    ),
                  },
                ],
              },
            });
          }
        } else {
          searchCondition.push({
            $expr: {
              $eq: [
                { $toDate: `$${columnname}` },
                {
                  $toDate: this.datePipe.transform(inputValue[0], 'yyyy-MM-dd'),
                },
              ],
            },
          });
        }
      }

      if (i === 0 || val.operator === 'OR') {
        orArr.push({ $or: searchCondition });
      } else {
        andArr.push({ $or: searchCondition });
      }
    });
    if (orArr.length > 0) {
      andArr.push({ $or: orArr });
    }
    return andArr;
  }
  patentCondition(columnValue: any, columnname: any, operator: any) {
    let andArr = [];
    let searchCondition = [];
    if (operator === 'NOT') {
      if (this.searchType === 'Exact') {
        searchCondition.push({
          [columnname]: {
            $not: {
              $regex: `\\${columnValue.slice(0, columnValue.indexOf(' '))}\\b`,
              $options: 'i',
            },
          },
        });
      } else {
        searchCondition.push({
          [columnname]: {
            $not: {
              $regex: columnValue.slice(0, columnValue.indexOf(' ')),
              $options: 'i',
            },
          },
        });
      }
    } else {
      this.dynSelectedPatentType = columnValue;

      if (this.searchType === 'Exact') {
        searchCondition.push({
          [columnname]: {
            $regex: `\\${columnValue.slice(0, columnValue.indexOf(' '))}\\b`,
            $options: 'i',
          },
        });
        this.textsearch += ` ${columnValue.slice(0, columnValue.indexOf(' '))}`;
      } else {
        searchCondition.push({
          [columnname]: {
            $regex: columnValue.slice(0, columnValue.indexOf(' ')),
            $options: 'i',
          },
        });
      }
    }
    andArr.push({ $or: searchCondition });

    return andArr;
  }

  rangeCondition(columnValue: any, columnname: any, operator: any) {
    let andArr: any = [];
    let searchCondition: any = [];
    let valueArr = columnValue.split('-');
    // console.log(valueArr);
    let regex = /(?<stringValue>[a-z]+)(?<numericValue>[0-9]+)/i;
    const startMatch: any = regex.exec(valueArr[0]);
    const endMatch: any = regex.exec(valueArr[1]);

    if (operator === 'NOT') {
      searchCondition.push({
        [columnname]: {
          $not: {
            $regex: columnValue.slice(0, columnValue.indexOf(' ')),
            $options: 'i',
          },
        },
      });
    } else {
      searchCondition.push({
        numericPart: {
          $gte: parseInt(startMatch.groups.numericValue),
          $lte: parseInt(endMatch.groups.numericValue),
        },
        stringPart: {
          $gte: startMatch.groups.stringValue,
          $lte: endMatch.groups.stringValue,
        },
      });
    }
    andArr.push({ $or: searchCondition });

    return andArr;
  }
  textFieldCondition(colValArr: any, columnname: any, operator: any) {
    let andArr: any = [];
    let orArr: any = [];
    colValArr.forEach((val: any, i: any) => {
      let searchWordArr: any = [];
      let searchCondition: any = [];
      searchWordArr.push(val.value.replace(/[^a-zA-Z0-9\s]/g, '\\$&'));
      searchWordArr.push(val.value.replace(/[^\w\s]+/gi, ''));
      searchWordArr.push(val.value.replace(/[^\w\s]+/gi, ' '));
      if (operator === 'NOT') {
        searchWordArr.forEach((text: any) => {
          if (this.searchType === 'Exact') {
            searchCondition.push({
              [columnname]: {
                $not: { $regex: `\\b${text}\\b`, $options: 'i' },
              },
            });
          } else {
            searchCondition.push({
              [columnname]: { $not: { $regex: text, $options: 'i' } },
            });
          }
        });
      } else {
        searchWordArr.forEach((text: any) => {
          if (this.searchType === 'Exact') {
            searchCondition.push({
              [columnname]: { $regex: `\\b${text}\\b`, $options: 'i' },
            });
          } else {
            searchCondition.push({
              [columnname]: { $regex: text, $options: 'i' },
            });
          }
        });
        if (this.searchType === 'Exact') {
          this.textsearch += ` ${val.value}`;
        }
      }

      if (i === 0 || val.operator === 'OR') {
        orArr.push({ $or: searchCondition });
      } else {
        andArr.push({ $or: searchCondition });
      }
    });
    if (orArr.length > 0) {
      andArr.push({ $or: orArr });
    }

    return andArr;
  }

  checkUserSearchPrivillege(): boolean {
    this.IsFilterAplied = false;

    if (!this.privilege_json) {
      const stored = localStorage.getItem('userPrivilege') || localStorage.getItem('user_privilege');
      if (stored) {
        try {
          this.privilege_json = JSON.parse(stored);
        } catch (e) {}
      }
    }

    const canView = this.privilege_json && (
      this.privilege_json.View === true || 
      (this.privilege_json.View as any) === 'true' || 
      (this.privilege_json.View as any) === 1 || 
      (this.privilege_json.View as any) === '1'
    );

    if (!canView) {
      this.is_show_Search_Priv_popup = true;
      if (this.messageService) {
        this.messageService.add({
          severity: 'error',
          summary: 'Access Denied',
          detail: 'You do not have privilege to view this database.',
        });
      }
      return false;
    }

    //Check Daily Search Exceed
    const todaySearchCount =
      Number(this.privilege_json.today_search_count) || 0;
    const dailySearchLimit = Number(this.privilege_json.DailySearchLimit) || 0;
    if (todaySearchCount >= dailySearchLimit) {
      this.is_show_Daily_Search_Exceed_popup = true;
      this.messageService.add({
        severity: 'warn',
        summary: 'Limit Reached',
        detail: 'You have reached your daily search limit.',
      });
      return false;
    }
    //Check Total Search Exceed
    const searchCount = Number(this.privilege_json.Search) || 0;
    if (searchCount <= 0) {
      this.is_show_Total_Search_Exceed_popup = true;
      this.messageService.add({
        severity: 'warn',
        summary: 'Limit Reached',
        detail: 'You have reached your total available search limit.',
      });
      return false;
    }

    this.IsFilterAplied = true;
    this.privilege_json.Search = searchCount - 1;
    this.privilege_json.today_search_count = todaySearchCount + 1;

    // Save updated counts to localStorage
    const userid = this.user_data?.userid || 'guest';
    const dailyKey = `user_${userid}_daily_counts`;

    const today = new Date().toDateString();
    localStorage.setItem(
      dailyKey,
      JSON.stringify({
        date: today,
        today_search_count: this.privilege_json.today_search_count,
        today_download_count: this.privilege_json.today_download_count || 0,
      })
    );
    return true;
  }

  resetForm() {
    this.commanService.advanceformvalue.next({});
    this.filterForm_advanced.reset(); // Resets all fields to their default state
  }
  resetallform() {
    this.commanService.resetFlag.next(true);
  }
  checkUserDownloadPrivillege(): boolean {
    console.log('Checking download privileges');
    //Check User Have Access to Search
    if (!this.privilege_json.Download) {
      console.log('User does not have download access');
      this.is_show_Download_Priv_popup = true;
      this.messageService.add({
        severity: 'error',
        summary: 'Access Denied',
        detail: 'You do not have privilege to download data from this database.',
      });
      return false;
    }
    //Check Daily Search Exceed
    const todayDownloadCount =
      Number(this.privilege_json.today_download_count) || 0;
    const dailyDownloadLimit =
      Number(this.privilege_json.DailyDownloadLimit) || 0;
    console.log(
      `Checking daily download limit: today=${todayDownloadCount}, limit=${dailyDownloadLimit}`
    );
    if (todayDownloadCount >= dailyDownloadLimit) {
      console.log('Daily download limit exceeded');
      this.is_show_Daily_Download_Exceed_popup = true;
      this.messageService.add({
        severity: 'warn',
        summary: 'Limit Reached',
        detail: 'You have reached your daily download limit.',
      });
      return false;
    }
    //Check Total Search Exceed
    const downloadCount = Number(this.privilege_json.DownloadCount) || 0;
    console.log(`Checking total download count: remaining=${downloadCount}`);
    if (downloadCount <= 0) {
      console.log('Total download count exceeded');
      this.is_show_Total_Download_Exceed_popup = true;
      this.messageService.add({
        severity: 'warn',
        summary: 'Limit Reached',
        detail: 'You have reached your total available download limit.',
      });
      return false;
    }
    this.privilege_json.DownloadCount = downloadCount - 1;
    this.privilege_json.today_download_count = todayDownloadCount + 1;

    // Save updated counts to localStorage
    const today = new Date().toDateString();
    const userData = {
      date: today,
      today_search_count: this.privilege_json.today_search_count,
      today_download_count: this.privilege_json.today_download_count,
    };
    localStorage.setItem(
      `user_${this.user_data.userid}_daily_counts`,
      JSON.stringify(userData)
    );

    console.log(
      `Updated download counts: total=${this.privilege_json.DownloadCount}, today=${this.privilege_json.today_download_count}`
    );

    return true;
  }
  setIpandLocation() {
    this.datasearch.getIpandLocation().subscribe({
      next: (res) => {
        this.user_ip = res.userip;
        this.address = res.address;
        console.log('🌐 User Info:', res);
      },
      error: (err) => {
        console.error('❌ Error fetching IP/Location:', err);
      },
    });
  }
  updatesimplesearch() {
    this.commanService.advanceformvalue.subscribe((res) => {
      this.advanceformvalue = res;
      this.filterForm_advanced.patchValue({
        advfilters: this.advanceformvalue.advfilters,
        ddloprator: this.advanceformvalue.ddloprator,
        txtfiltervalue: this.advanceformvalue.txtfiltervalue,
      });
    });
  }
  dataForTable(data: any, count: any) {
    if (this.isDataApiDone && this.isCountApiDone) {
      const gbrnArray = data.map((item: any) => item.gbrn);
      const inchiKeyArray = data.map((item: any) => item.inchiKey);
      const activeIngredientArray = data.map(
        (item: any) => item.activeIngredient
      );

      this.commanService.currentData.next({
        inchiKey: data[0]?.inchiKey,
        gbrn: data[0]?.gbrn,
        activeIngredient: data[0]?.activeIngredient,
        data: data,
        userid: this.user_data.userid,
        currentFilterCondition: this.currentFilterCondition,
        application_query: this.application_query,
        search_filters: this.search_filters,
        cols: data[1] || [],
        columns: this.columns,
        totalRecords: count,
        searchQueryGrid: this.searchQueryGrid,
        gbrnArray: gbrnArray,
        inchiKeyArray: inchiKeyArray,
        activeIngredientArray: activeIngredientArray,
      });

      this.isDataApiDone = false;
      this.isCountApiDone = false;
      this.tableData = null;

      if (this.totalRecords === 0) {
        this.noResultsFound = true;
      } else {
        this.noResultsFound = false;
      }
    } else {
      return;
    }
  }
}
